export default __webpack_public_path__ + "static/media/info_24px.84b80825.svg";